import React, { useState } from 'react'
import { StyleSheet, View } from 'react-native'
import delay from 'delay'

import {
    AnimatedEllipsis,
    Title,
    Button,
    Space,
    ButtonTitle,
    Text
} from '@sart/components'
import {
    CompanyIcon
} from '@sart/icons'
import { useContent } from '@sart/content'
import { colors, typography, adaptive } from '@sart/styles'
import { testID } from '@sart/utilities'
import client from '@sart/client'

export default function RegistrationNewCustomerConfirmation(props) {
    const { navigation, route } = props

    const order = route.params?.order
    const password = route.params?.password
    const email = route.params?.email
    const [submitting, setSubmitting] = useState(false)

    // console.log('activateSubscriptionResult is: ');
    // console.log(JSON.stringify(activateSubscriptionResult.serviceAddItems[0].service.lineIdentifier, null, 2));
    const content = useContent()
    const newNumber = order && order.accountAddItems && order.accountAddItems[0] && order.accountAddItems[0].message && order.accountAddItems[0].message.substring(12)

    async function createTokenAndActivate(tryCount) {
        setSubmitting(true)
        let auth
        // maybe wait a couple of seconds before trying to get a token, and might have to loop it as we are
        // still not sure how long the registration will take to go through successfully
        try {
            auth = await client.signInWithPasswordAndEmail({email,password})
        } catch (error) {
            console.log(error)
            if(tryCount < client.configuration.pollingMaxRetries) {
                tryCount ++
                await delay(client.orderRefreshTime)
                await createTokenAndActivate(tryCount)
            } else {
                console.log(JSON.stringify(error))
                setSubmitting(false)
            }
        }
        if(auth !== undefined){
            client.activateService(auth.customerId)
            navigation.navigate('Main')    
        }
    }

    return (
        <View style={styles.container}>
            <View style={styles.logo}>
                <CompanyIcon color={colors.white} height={styles.logoStyle.height} width={200} />
            </View>
            <Space height={48} />

            <Title style={styles.title} {...testID('NewCustomerTitle')}>{content.checkout.yourNewNumberIs}</Title>
            <Title style={styles.title} {...testID('NewCustomerNumber')}>{newNumber}</Title>

            <Space height={64} />

            <Button
                style={styles.enabled}
                title={!submitting 
                    ? content.register_new_customer.buttonTitle 
                    : <ButtonTitle style={{...typography.extrabold, fontSize: 18}}>{content.register_new_customer.buttonSubmitting} <AnimatedEllipsis style={{fontSize:24, color:colors.clear, ...typography.extrabold}}/></ButtonTitle>
                    
                }
                onPress={() => {
                    createTokenAndActivate(0)
                }}
                titleStyle={styles.buttonTitle}
                disabled={submitting}
                disabledStyle={styles.disabled}
                {...testID('NewCustomerSubmit')}
            />

            <Space height={16} />

            <Text style={styles.giveUs5Minutes}>{content.register_new_customer.giveUs5Minutes}</Text>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        ...adaptive.wrapperPadding,
        backgroundColor: colors.srDarkGreen,
        justifyContent: 'center',
        alignItems: 'center',
    },
    title: {
        color: colors.clear,
        ...typography.bold,
        textAlign: 'center'
    },
    enabled: {
        alignSelf: 'stretch',
        backgroundColor: colors.srGreen,
        height: 48
    },
    buttonTitle: { 
        ...typography.extrabold, 
        fontSize: 18 
    },
    disabled: {
        alignSelf: 'stretch',
        backgroundColor: colors.white+50
    },
    giveUs5Minutes: {
        fontSize: 16,
        textAlign: 'center',
        color: colors.white,
        ...typography.demi
    },
    logo: {
        alignSelf:"center"
      },
    logoStyle: {
        ...adaptive.guruSize
      },
})
